import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { map } from 'rxjs/operators'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class FundHistoryService {
  url: string | null = null
  constructor (private http: HttpClient) {
    this.url = environment.baseApiUrl + 'admin/'
  }

  getAll () {
    return this.http
      .get(
        environment.production
          ? environment.baseApiUrl + 'fund/history'
          : environment.baseApiUrlTest + 'fund/history'
      )
      .pipe(
        map((response: any) => {
          return response['data']
        })
      )
  }

  get (agentId: string): Observable<any> {
    return this.http
      .get(
        environment.production
          ? environment.baseApiUrl + 'fund/history/' + agentId
          : environment.baseApiUrlTest + 'fund/history/' + agentId
      )
      .pipe(
        map((response: any) => {
          return response['data']
        })
      )
  }
  getFund (id: string): Observable<any> {
    return this.http
      .get(
        environment.production
          ? environment.baseApiUrl + 'fund/details/' + id
          : environment.baseApiUrlTest + 'fund/details/' + id
      )
      .pipe(
        map((response: any) => {
          return response
        })
      )
  }

  uploadFund (data: any): Observable<any> {
    return this.http
      .post(
        environment.production
          ? environment.baseApiUrl + 'fund/upload'
          : environment.baseApiUrlTest + 'fund/upload',
        data
      )
      .pipe(
        map((response: any) => {
          return response
        })
      )
  }

  revertFund (id: string): Observable<any> {
    return this.http
      .post(
        environment.production
          ? environment.baseApiUrl + 'fund/revert'
          : environment.baseApiUrlTest + 'fund/revert',
        { id }
      )
      .pipe(
        map((response: any) => {
          return response
        })
      )
  }

  filter (data: any): Observable<any> {
    return this.http
      .post(
        environment.production
          ? environment.baseApiUrl + 'fund/history/filter'
          : environment.baseApiUrlTest + 'fund/history/filter',
        data
      )
      .pipe(
        map((response: any) => {
          return response['data']
        })
      )
  }
}
